import { useTranslation } from 'react-i18next'

import { Text, TextArea } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const RefundNotes = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleS">{t('Notas')}</Text>
      <TextArea fullWidth value={value} maxLength={100} showCounter onChange={e => onChange(e.target.value)} />
    </Styles.Container>
  )
}

export default RefundNotes
